import React from 'react';
import {Flex, Text} from '@chakra-ui/react';
import {FilterSelect, FilterSelectHeight} from './FilterSelect';

export const OperatorElement = ({
  operator,
  isEditable,
  onOperatorChange,
}: {
  operator: 'and' | 'or';
  isEditable: boolean;
  onOperatorChange: (operator: 'and' | 'or') => void;
}) => {
  const operatorOptions = [
    {label: 'and', value: 'and'},
    {label: 'or', value: 'or'},
  ];

  if (isEditable) {
    return (
      <FilterSelect
        variant="operator"
        options={operatorOptions}
        value={operatorOptions.find((opt) => opt.value === operator)}
        onChange={(selected) => {
          if (selected) {
            onOperatorChange(selected.value as 'and' | 'or');
          }
        }}
        styles={{
          container: (base) => ({
            ...base,
            width: '100%',
          }),
        }}
      />
    );
  }

  return (
    <Flex height={FilterSelectHeight} alignItems="center">
      <Text color="kgray.300" pl={2.5}>
        {operator}
      </Text>
    </Flex>
  );
};
